export function Expandable() {
  const elem = document.querySelectorAll(".expandable")

  elem.forEach((element) => {
    const gridItems = element.querySelectorAll(".tile-grid__container--item")
    let counter = 5
    const showMore = document.createElement("button")

    function showNextSix() {
      gridItems.forEach((element, i) => {
        if (counter < i < counter + 6) element.classList.remove("hiding")
      })
      counter = counter + 6
      if (counter > gridItems.length) {
        showMore.remove()
      }
    }

    showMore.innerHTML = "Show More"
    showMore.classList.add("btn", "btn-primary", "btn-show-more")
    showMore.addEventListener("click", showNextSix, false)

    function hideExtraItems() {
      gridItems.forEach((element, i) => {
        if (i > 5) {
          element.classList.add("hiding")
        }
      })
    }

    function addShowMore() {
      element.appendChild(showMore)
    }

    hideExtraItems()
    addShowMore()
  })
}
